import { useState } from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// This is our UI. It does not load or invoke Paytm CheckoutJS.
const PaytmIntentPayment = ({ amount, userDetails, onClose }) => {
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");

  const payWithPhonePe = async () => {
    try {
      setProcessing(true);
      setError("");
      const orderId = `INTENT_${Date.now()}`;
      const baseUrl = process.env.REACT_APP_PHONEPE_NODE_URL;
      const { data: intent } = await axios.post(`${baseUrl}/api/paytm/intent/create`, {
        orderId,
        amount,
        customerId: `CUST_${Date.now()}`,
        name: userDetails?.fullname,
        mobile: userDetails?.mobile ? `+91${userDetails.mobile}` : "",
        domainname: window.location.hostname,
      });
      const { data } = await axios.post(`${baseUrl}/api/paytm/intent/process-upi`, {
        orderId,
        txnToken: intent?.txnToken,
      });
      if (!data?.deepLink) throw new Error(data?.message || "PhonePe UPI Intent could not be started");

      // Paytm returns the UPI deeplink. On a mobile device it hands control to
      // the installed UPI app; routing it to PhonePe-only needs Paytm approval.
      window.location.assign(data.deepLink);
    } catch (requestError) {
      setError(requestError?.response?.data?.message || requestError.message || "Payment could not be started. Please try again.");
      setProcessing(false);
    }
  };

  return (
    <Modal show onHide={processing ? undefined : onClose} centered backdrop="static">
      <Modal.Header closeButton={!processing}>
        <Modal.Title>Complete payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between mb-3 fw-bold">
          <span>Total</span><span>₹{amount}</span>
        </div>
        <div className="border rounded p-3 d-flex align-items-center">
          <span className="me-2" aria-hidden="true">🟣</span>
          <div><strong>PhonePe</strong><div className="small text-muted">Pay securely with UPI</div></div>
        </div>
        {error && <div className="text-danger small mt-3">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" disabled={processing} onClick={onClose}>Cancel</Button>
        <Button variant="dark" disabled={processing} onClick={payWithPhonePe}>
          {processing ? "Opening PhonePe..." : `Pay ₹${amount}`}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaytmIntentPayment;
